import { queryOptions } from "@tanstack/react-query";
import type { Audiences } from "@zora/api/concerns/audiences/audience.router";
import { axios, buildHeaders } from "./axios";
import { buildHonoHeaders, honoAxios } from "./hono-axios";

export const residentsQueryOptions = queryOptions({
  queryKey: ["residents"],
  queryFn: () => fetchResidents(),
});

export const fetchResidents = async () => {
  return axios
    .get<Audiences>("/audiences", {
      headers: buildHeaders(),
    })
    .then((r) => r.data);
};

export const residentQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ["resident", id],
    queryFn: () => fetchResident(id),
  });

export const fetchResident = async (id: string) => {
  return honoAxios
    .get(`/residents/${id}`, {
      headers: buildHonoHeaders(),
    })
    .then((r) => r.data);
};
